
const ChinaFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" fill="none">
            <rect y="0.5" width="22" height="16" rx="2" fill="white" />
            <mask id="mask0_1325_7467" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                <rect y="0.5" width="22" height="16" rx="2" fill="white" />
            </mask>
            <g mask="url(#mask0_1325_7467)">
                <rect y="0.5" width="22" height="16" fill="#F1361D" />
                <path d="M9.40527 9.41113L9.83008 10.0674L9.05762 10.0771L8.41309 10.5088L8.40332 9.72266L7.97949 9.06641L8.75098 9.05664L9.39648 8.625L9.40527 9.41113ZM10.5674 6.9082L11.334 6.82129L10.9922 7.52637L11.0771 8.30762L10.3848 7.95898L9.61816 8.04492L9.95996 7.34082L9.875 6.55957L10.5674 6.9082ZM10.9824 4.62891L11.3828 5.2998L10.6113 5.28223L9.95215 5.69043L9.96973 4.90527L9.56836 4.2334L10.3408 4.25195L11 3.84277L10.9824 4.62891ZM9.13379 2.1543L9.89551 2.28613L9.375 2.86719L9.24609 3.64258L8.6748 3.11328L7.91406 2.98047L8.43359 2.39941L8.56348 1.625L9.13379 2.1543Z" fill="#FFDC42" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.23807 7.0813L3.39075 8.42216L4.07235 6.21895L2.24904 4.84445L4.51762 4.82365L5.23807 2.6333L5.95853 4.82365L8.22711 4.84445L6.4038 6.21895L7.0854 8.42216L5.23807 7.0813Z" fill="#FFDC42" />
            </g>
        </svg>
    )
}

export default ChinaFlag